import branding from 'shared/app/model/branding';
export function showThemeElement() {
    return branding.enable_dark_theme;
}
